window.jQuery(document).ready(function() {
  // course overview slider
  window.jQuery('.course-overview-slider').owlCarousel({
    items: 4,
    loop: false,
    margin: 20,
    dots: false,
    navText: [
      "<i class='fas fa-long-arrow-left'></i>",
      "<i class='fas fa-long-arrow-right'></i>"
    ],
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        nav: true
      },
      480: {
        items: 1,
        nav: true
      },
      576: {
        items: 1,
        nav: true
      },
      768: {
        items: 2,
        nav: true
      },
      992: {
        items: 3,
        nav: true
      },
      1200: {
        items: 4,
        nav: false,
        loop: false
      }
    }
  });

  // latest news slider
  window.jQuery('.news-slider').owlCarousel({
    items: 4,
    loop: false,
    margin: 0,
    dots: false,
    navText: [
      "<i class='fas fa-long-arrow-left'></i>",
      "<i class='fas fa-long-arrow-right'></i>"
    ],
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        nav: true
      },
      480: {
        items: 1,
        nav: true
      },
      576: {
        items: 1,
        nav: true
      },
      768: {
        items: 2,
        nav: true
      },
      992: {
        items: 3,
        nav: true
      },
      1200: {
        items: 4,
        nav: false,
        loop: false
      }
    }
  });

  // convert svg in image path to convas
  window.jQuery('img.svg').each(function() {
    var $img = window.jQuery(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    window.jQuery.get(
      imgURL,
      function(data) {
        // Get the SVG tag, ignore the rest
        var $svg = window.jQuery(data).find('svg');

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Replace image with new SVG
        $img.replaceWith($svg);
      },
      'xml'
    );
  });
});
